/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
export type PredictedEndDateModal_project = {
    readonly id: string;
    readonly name: string | null;
    readonly status: PROJECT_STATUS | null;
    readonly projectHealth: {
        readonly totalTaskEstimate: number | null;
        readonly predictedAverageScopePerDay: number | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PredictedEndDateModalChartSection_project" | "PredictedEndDateModalStatsSection_project">;
    readonly " $refType": "PredictedEndDateModal_project";
};
export type PredictedEndDateModal_project$data = PredictedEndDateModal_project;
export type PredictedEndDateModal_project$key = {
    readonly " $data"?: PredictedEndDateModal_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PredictedEndDateModal_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PredictedEndDateModal_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectHealth",
      "kind": "LinkedField",
      "name": "projectHealth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalTaskEstimate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "predictedAverageScopePerDay",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PredictedEndDateModalChartSection_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PredictedEndDateModalStatsSection_project"
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = '8153c292be66165f12413a3228c95d2e';
export default node;
